export default "__VITE_ASSET__CLEOVNRb__"